import { render, staticRenderFns } from "./remaked.vue?vue&type=template&id=60d0e069&scoped=true&lang=pug"
import script from "./remaked.vue?vue&type=script&lang=js"
export * from "./remaked.vue?vue&type=script&lang=js"
import style0 from "./remaked.vue?vue&type=style&index=0&id=60d0e069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0e069",
  null
  
)

export default component.exports